export default __webpack_public_path__ + "static/media/details.fe282589.svg";